import React from 'react';
import Svg, { Path, Rect } from 'react-native-svg';

interface SendIconProps {
  color?: string;
  fillColor?: string;
}

export const SendIcon = ({color = '#1C1C1C', fillColor = 'transparent'}: SendIconProps) => (
  <Svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
  >
    <Rect width="46" height="46" rx="23" fill={fillColor} />
    <Path
      d="M25.3232 30.0711C25.358 30.15 25.4186 30.2174 25.4967 30.2641C25.5748 30.3108 25.6668 30.3347 25.7603 30.3325C25.8538 30.3303 25.9443 30.3022 26.0197 30.2519C26.0951 30.2016 26.1518 30.1316 26.1821 30.0511L32.1404 14.2178C32.1698 14.144 32.1754 14.0641 32.1566 13.9874C32.1378 13.9108 32.0954 13.8406 32.0343 13.7851C31.9732 13.7296 31.8961 13.6911 31.8118 13.674C31.7275 13.6569 31.6396 13.662 31.5584 13.6886L14.1417 19.1053C14.0532 19.1329 13.9762 19.1844 13.9208 19.253C13.8655 19.3215 13.8346 19.4038 13.8322 19.4888C13.8298 19.5738 13.856 19.6574 13.9074 19.7284C13.9588 19.7994 14.0329 19.8545 14.1197 19.8861L21.3889 22.5361C21.6186 22.6198 21.8274 22.7449 22.0026 22.9038C22.1778 23.0628 22.3158 23.2524 22.4082 23.4611L25.3232 30.0711Z"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M32.0322 13.7891L22.0039 22.9049"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);
